import { SKU_BOOKING_REF_QUERY } from './skuBooking'

export const PHARMACY_DETAIL_SKU_ID_QUERY = 'sku_id'
export const PHARMACY_DETAIL_SKU_NAME_QUERY = 'sku_name'
export const PHARMACY_DETAIL_MED_NAME_QUERY = 'med_name'

/** The medication a customer was viewing before clicking into a pharmacy's detail page
 *  from the Compare pharmacies drawer — carried as query params so the detail page can
 *  offer a floating "Request medication" button that re-enters that SKU's booking flow
 *  (see RequestMedicationFloatingCta). */
export interface PharmacyDetailSkuContext {
    skuId: number
    skuHyphenatedName: string
    productName: string
    ref?: string | null
}

export const pharmacyRoutes = {
    /**
     * Public pharmacy directory detail page.
     * Example: /pharmacy/walgreens-pharmacy/12345
     */
    detail(pharmacyName: string, friendlyId: string | number): string {
        return `/pharmacy/${pharmacyName}/${friendlyId}`
    },

    /**
     * Pharmacy-scoped medication selection before booking.
     * Example: /pharmacy/walgreens-pharmacy/12345/request-prescription
     */
    requestPrescription(pharmacyName: string, friendlyId: string | number): string {
        return `/pharmacy/${pharmacyName}/${friendlyId}/request-prescription`
    },

    /**
     * Medication product detail page for a pharmacy-directory offering.
     * Example: /dp/zepbound/701128
     */
    medicationProductDetail(slug: string, skuId: string | number): string {
        return `/dp/${slug}/${skuId}`
    },

    /**
     * Pharmacy detail page reached from a medication PDP's Compare pharmacies drawer.
     * Example: /pharmacy/walgreens-pharmacy/12345?sku_id=123&sku_name=omeprazole-20mg&med_name=Omeprazole
     */
    detailFromMedicationPdp(
        pharmacyName: string,
        friendlyId: string | number,
        skuContext: PharmacyDetailSkuContext,
    ): string {
        const query = new URLSearchParams()
        query.set(PHARMACY_DETAIL_SKU_ID_QUERY, String(skuContext.skuId))
        query.set(PHARMACY_DETAIL_SKU_NAME_QUERY, skuContext.skuHyphenatedName)
        query.set(PHARMACY_DETAIL_MED_NAME_QUERY, skuContext.productName)
        if (skuContext.ref) query.set(SKU_BOOKING_REF_QUERY, skuContext.ref)

        return `${pharmacyRoutes.detail(pharmacyName, friendlyId)}?${query.toString()}`
    },
}
